import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import AdUnit from '../components/AdUnit';

const NotFoundPage = () => {
  return (
    <>
      <SEO 
        title="404 - Page Not Found | JSON Tools" 
        description="The page you're looking for doesn't exist. Explore our comprehensive JSON tools including beautifier, validator, escape/unescape, and more."
        keywords={["404", "page not found", "JSON tools", "JSON beautifier", "JSON validator", "JSON utilities"]}
        canonicalUrl="https://yourjsontools.com/404"
      />
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px', lineHeight: '1.6', color: '#333', textAlign: 'center' }}>

        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ fontSize: '72px', color: '#e74c3c', marginBottom: '20px', fontWeight: 'bold' }}>404</h1>
          <h2 style={{ fontSize: '32px', color: '#2c3e50', marginBottom: '20px' }}>Page Not Found</h2>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px' }}>
            Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        <div style={{ marginBottom: '50px' }}>
          <Link 
            to="/" 
            style={{ 
              display: 'inline-block',
              backgroundColor: '#3498db', 
              color: 'white', 
              padding: '15px 30px', 
              textDecoration: 'none', 
              borderRadius: '5px', 
              fontSize: '16px',
              fontWeight: 'bold',
              margin: '10px',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
          >
            🏠 Go to Homepage
          </Link>
        </div>

        <div style={{ backgroundColor: '#f8f9fa', padding: '40px', borderRadius: '10px', marginBottom: '40px' }}>
          <h3 style={{ fontSize: '24px', color: '#2c3e50', marginBottom: '25px' }}>Popular JSON Tools</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', textAlign: 'left' }}>
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/json-beautifier" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#3498db', marginBottom: '10px' }}>🎨 JSON Beautifier</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Format and beautify your JSON data with proper indentation</p>
              </Link>
            </div>
            
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/json-escape-unescape" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#e74c3c', marginBottom: '10px' }}>🔤 JSON Escape/Unescape</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Escape and unescape JSON strings safely</p>
              </Link>
            </div>
            
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/schema-validator" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#2ecc71', marginBottom: '10px' }}>✅ Schema Validator</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Validate JSON against schema definitions</p>
              </Link>
            </div>
            
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/json-compare" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#f39c12', marginBottom: '10px' }}>⚖️ JSON Compare</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Compare two JSON objects and find differences</p>
              </Link>
            </div>
            
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/json-path-finder" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#9b59b6', marginBottom: '10px' }}>🔍 JSON Path Finder</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Find JSON paths and extract specific values</p>
              </Link>
            </div>
            
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Link to="/dummy-files" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h4 style={{ color: '#34495e', marginBottom: '10px' }}>📁 Dummy Files Generator</h4>
                <p style={{ color: '#666', fontSize: '14px' }}>Generate dummy images and PDF files for testing</p>
              </Link>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ fontSize: '20px', color: '#2c3e50', marginBottom: '15px' }}>Other Helpful Tools</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
            <Link to="/html-beautifier" style={{ color: '#3498db', textDecoration: 'none', padding: '5px 10px', border: '1px solid #3498db', borderRadius: '20px', fontSize: '14px' }}>
              HTML Beautifier
            </Link>
            <Link to="/html-viewer" style={{ color: '#e74c3c', textDecoration: 'none', padding: '5px 10px', border: '1px solid #e74c3c', borderRadius: '20px', fontSize: '14px' }}>
              HTML Viewer
            </Link>
            <Link to="/letter-count" style={{ color: '#2ecc71', textDecoration: 'none', padding: '5px 10px', border: '1px solid #2ecc71', borderRadius: '20px', fontSize: '14px' }}>
              Letter Counter
            </Link>
            <Link to="/x-counter" style={{ color: '#f39c12', textDecoration: 'none', padding: '5px 10px', border: '1px solid #f39c12', borderRadius: '20px', fontSize: '14px' }}>
              X Counter
            </Link>
            <Link to="/csharp-to-json" style={{ color: '#9b59b6', textDecoration: 'none', padding: '5px 10px', border: '1px solid #9b59b6', borderRadius: '20px', fontSize: '14px' }}>
              C# to JSON
            </Link>
          </div>
        </div>

        <div style={{ backgroundColor: '#ecf0f1', padding: '30px', borderRadius: '8px', marginBottom: '40px' }}>
          <h3 style={{ fontSize: '18px', color: '#2c3e50', marginBottom: '15px' }}>Need Help?</h3>
          <p style={{ color: '#666', marginBottom: '15px' }}>
            If you think this is an error or you were looking for a specific tool, here are some suggestions:
          </p>
          <ul style={{ textAlign: 'left', color: '#666', maxWidth: '500px', margin: '0 auto' }}>
            <li style={{ marginBottom: '8px' }}>Check the URL for typos</li>
            <li style={{ marginBottom: '8px' }}>Use the search feature in your browser (Ctrl+F)</li>
            <li style={{ marginBottom: '8px' }}>Browse our complete list of tools on the homepage</li>
            <li style={{ marginBottom: '8px' }}>Bookmark frequently used tools for quick access</li>
          </ul>
        </div>

      </div>
    </>
  );
};

export default NotFoundPage; 